import { useEffect, useState } from 'react';
import { Lang } from '../api/lang';
import { getInitialLang, getStoredLang, setStoredLang } from '../api/langStorage';
import { verify } from '../api/api';
import { useHistory } from 'react-router';
import { getStoredRes } from '../api/resStorage';

const Verify = () => {
  const [lang, setLang] = useState<string>(() => getStoredLang());
    const [resolution, setResolution] = useState<string>(() => getStoredRes());
    const [isPortrait, setIsPortrait] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error,setError]=useState<string>("");
    const [rotate,setRotate]=useState<number>(0);

    const navigate = useHistory();

    const handleLangChange = (value: string) => {
      setStoredLang(value);
      setLang(value);
    }
    
    useEffect(() => {
        document.body.style.backgroundColor = "black";
      const params = new URLSearchParams(window.location.search);
      setLang(getInitialLang(window.location.search));
        verify(params.get('token') || '').then((res)=>{
            setLoading(false);
        }).catch((err)=>{
            setLoading(false);
            if (err.response!==undefined && err.response.status===400) {
                setError(err.response.data.error);
            } else {
                setError("network_error");
            }
        }); 
        //ทำ animation หมุนรอ ช้าๆ
        const interval = setInterval(() => {
            setRotate((prevRotate) => (prevRotate + 0.1) % 360);
        }, 100);
        return () => clearInterval(interval);
    }, []);


  useEffect(() => {
    document.title=Lang.get(lang,"lethal_blade_title");
  }, [lang]);

  const handleback=()=> { 
    navigate.replace("/?lang="+lang+"&resolution="+resolution);
  }

  return (<>
        <div className="c" style={{width:"100%",paddingRight:"10px",paddingTop:"10px",overflowX: "hidden",position: "absolute",zIndex: 9999}}>
        <table><tbody><tr>
        <td width="80%"></td>
        <td width="220px" style={{textAlign: "right",whiteSpace: "nowrap"}}>
          {Lang.get(lang,"bandwidth")}&nbsp;&nbsp;
        </td>
        <td width="80px">
        <select value={resolution} className="form-select form-select-sm form-control-sm" onChange={e=>{setResolution(e.currentTarget.value)}} style={{width:"70px"}}>
          <option value="low" >{Lang.get(lang,"low")}</option>
          <option value="high" >{Lang.get(lang,"high")}</option>
        </select>
        </td>
        <td width="80px">
        <select value={lang} className="form-select form-select-sm form-control-sm" onChange={e=>{handleLangChange(e.currentTarget.value)}} style={{width:"70px"}}>
          <option value="th">ไทย</option>
          <option value="en">Eng</option>
        </select>
        </td>
        </tr></tbody></table>
      </div>

      <div className="title c" style={{top:80,left: "50%",transform: "translate(-50%, 0)",position: "absolute",zIndex: 9999,opacity: 1.0}}>
          <img  src={"lethalblade/assets/"+resolution+"/title.png"} style={{width:"100%"}} alt={"Props"}/>
      </div>
       <div className="bg c" style={{justifyContent: "center", textAlign: "center",display:"block",opacity: 1.0,backgroundImage: "url(lethalblade/assets/"+resolution+"/bg2.jpg)"}}>
        &nbsp;
      </div>
      <div className="c" style={{top:200,left: "50%",transform: "translate(-50%, 0)",marginLeft:"10px",width: "400px",position: "absolute",zIndex: 9999,display: "block",textAlign: "center",justifyContent: "center",opacity: 1.0}}>
        <img src={"lethalblade/ assets/"+resolution+"/header.png"} alt="header" style={{width:"300px",height:"80px", transform: "scaleY(-1)"}}/><br/>
        { loading &&
         <><img src={"lethalblade/assets/"+resolution+"/loading.png"} alt="loading" style={{width:"50px",height:"50px",transform: `rotateZ(${rotate}deg)`,zIndex: 9999}}/><br/></>
        }
        { (!loading && error!=="") &&
            <><span style={{color:"red"}}>{ error}</span><br/></>
        }
        { (!loading && error==="") &&
            <><span className="header">{ Lang.get(lang,"verification_success")}</span><br/></>
        }
        { !loading &&
        <><div style={{height:"10px"}}></div>
        <div className="buttonup"  style={{cursor: "pointer",position:"relative"}} onClick={handleback}>
          <img src={"lethalblade/assets/"+resolution+"/buttonn.png"} alt="click"/>
          <div style={{position: "absolute",marginTop: "-5px",marginLeft:"-2px",top:"50%",left: "50%",transform: "translate(-50%, -50%)"}}>
            { Lang.get(lang,"back")}
          </div>
        </div></>
        }
        <img src={"lethalblade/assets/"+resolution+"/header.png"} alt="header" style={{width:"300px",height:"80px",marginTop:"-20px"}}/>
      </div>
      <div className="c" style={{position: "absolute",left: "50%",transform: "translate(-50%, 0)",marginLeft:"0px",bottom:"0px",zIndex: 999,whiteSpace: "nowrap"}}>
        { Lang.get(lang,"copyright_title")} { Lang.get(lang,"all_right_reserve_title")}
      </div>
      </>);
}


export default Verify;

